import SectionHeading from "./SectionHeading";
import { highlights } from "@/mocks/highlights";

const accentMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-700",
};

export default function Highlights() {
  return (
    <section id="highlights" className="w-full bg-background-100/70 px-4 py-16 md:px-8 md:py-24">
      <SectionHeading
        eyebrow="本季看点解析"
        title="这一季，值得留意的四个方向"
        description="除了单部作品的推荐，本季在演出方式、题材取向与观众参与度上也呈现出清晰的变化。"
      />

      <div className="mt-9 grid grid-cols-1 gap-5 md:grid-cols-2">
        {highlights.map((item) => (
          <article
            key={item.title}
            className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
          >
            <span
              className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-md ${accentMap[item.accent]}`}
            >
              <i className={`${item.icon} text-xl`} />
            </span>
            <div>
              <span className="text-[11px] font-medium uppercase tracking-wide text-foreground-400">
                {item.tag}
              </span>
              <h3 className="mt-1 text-lg text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.body}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}